var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7C7.43 7 9 8.57 9 10.5C9 12.43 7.43 14 5.5 14C3.57 14 2 12.43 2 10.5C2 8.57 3.57 7 5.5 7ZM5.5 5C2.46 5 0 7.46 0 10.5C0 13.54 2.46 16 5.5 16C8.54 16 11 13.54 11 10.5C11 9.34 10.64 8.27 10.03 7.38L14 3.42V6H16V0H10V2H12.58L8.61 5.97C7.73 5.36 6.66 5 5.5 5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/Male.0768dc9fd72c3c69dae7c93813fe413c.svg";
export { ForwardRef as ReactComponent };